<template>
  <section id="formsButton" class="container mx-auto border-t-2 mt-6">
    <!-- Parque Regular | Huesped -->
    <div
      id="formVisit"
      class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124"
    >
      <div class="uppercase text-center font-bold">
        {{ $t("Forms.visit_park_hotel") }}
      </div>

      <form class="flex flex-col w-full py-4 md:px-4">
        <select
          v-model="searchType"
          class="h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
        >
          <option value="" selected disabled>
            {{ $t("Forms.choose_option") }}
          </option>
          <option
            v-for="item in menuItems"
            :key="item?.EventId"
            :value="item?.EventId"
          >
            {{ item?.SelectedOption?.Label[getLanguage] }}
          </option>
        </select>

        <AddParkCode v-if="searchTypeSelected === AlbumSearchTypeEnum.REGULARPARK" />
        <AddRoom v-if="searchTypeSelected === AlbumSearchTypeEnum.ROOM" />
        <AddDownloadCode v-if="searchTypeSelected === AlbumSearchTypeEnum.DOWNLOADCODE" />
        <AddDynamicPark
          :event-config="menuItemSelected"
          v-if="searchTypeSelected === AlbumSearchTypeEnum.DYNAMIC_PARK"
        />
      </form>
    </div>
  </section>
</template>

<script>
import frontendConfig from "../../helpers/frontendConfig";
import AddParkCode from '../forms/AddPark.vue';
import AddRoom from '../forms/AddRoom.vue';
import AddDownloadCode from '../forms/AddDownloadCode.vue';
import AddDynamicPark from '../forms/AddDynamicPark.vue';

// Enums
import AlbumSearchTypeEnum from '@/enums/searchType.js';
const EXCLUDE_MENU_ITEMS_HOME = (frontendConfig.excludedMenuItems || '').split(',').map((item) => item.trim()).filter(Boolean);

export default {
  name: 'AddParkHotel',
  props: {},
  components: {
    AddParkCode,
    AddRoom,
    AddDownloadCode,
    AddDynamicPark
  },
  data() {
    return {
      searchType: "",
      AlbumSearchTypeEnum,
      menuItems: [],
      menuItemSelected: null,
      searchTypeSelected: null,
      parkId: null
    };
  },
  computed: {
    /**
     * Gets the active language from the store.
     */
    getLanguage() {
      return this.$store.getters.getLanguage;
    }
  },
  watch: {
    /**
     * Updates the selected search type and stores the banner configuration from EventSalesConfig.
     *
     * @param {String} newVal Selected EventId.
     */
    searchType(newVal) {
      const foundItem = this.menuItems.find(item => item?.EventId === newVal);
      this.menuItemSelected = foundItem || null;
      this.searchTypeSelected = foundItem ? foundItem?.SelectedOption?.Value : null;
      this.parkId = foundItem?.ParkId != null ? parseInt(foundItem.ParkId) : null;
      this.$store.dispatch(
        "setAlbumPromotionConfig",
        foundItem?.AlbumPromotionConfig || {}
      );
    }
  },
  methods: {
    /**
     * Loads and filters the search menu items available for the current route.
     *
     * @returns {Promise<Array<Object>>} Menu items that can be displayed.
     */
    async fillMenuItems() {
      let menuItems = await this.$store.dispatch("getOptions"); 
      menuItems = menuItems.filter(item => item?.SelectedOption);

      if(this.$router.currentRoute.name == "home") {
        menuItems = menuItems.filter(item => !EXCLUDE_MENU_ITEMS_HOME.includes(item?.EventId));
      }

      return menuItems;
    }
  },
  async created() {
    this.menuItems = await this.fillMenuItems();
  },
  mounted() {}
};
</script>